export const initMenu = () => {
    var openMobileMenu = document.getElementsByClassName('open-mobile-menu');
    const openDesktopMenu = document.querySelector('.open-desktop-menu');
    const siteMenu = document.getElementById('site-menu');
    const siteNavigation = document.getElementById('site-menu__content');
    var header = document.getElementById('site-header__container');

    for (var i = 0; i < openMobileMenu.length; i++) {
        openMobileMenu[i].addEventListener('click', () => {
            if (siteMenu.classList.contains('site-menu--visible-overflow')) {
                siteMenu.classList.remove('site-menu--visible-overflow');
            } else {
                setTimeout(function () {
                    siteMenu.classList.add('site-menu--visible-overflow');
                }, 400);
            }
            siteMenu.classList.toggle('site-menu--is-open');

        });
    }
    if (openDesktopMenu) {
        openDesktopMenu.addEventListener('mouseover', () => {
                siteMenu.classList.add('site-menu--is-open');
                setTimeout(function () {
                    siteMenu.classList.add('site-menu--visible-overflow');
                }, 400);
                siteMenu.addEventListener('mouseleave', () => {
                    siteMenu.classList.remove('site-menu--is-open');
                    siteMenu.classList.remove('site-menu--visible-overflow');
                });
            });
    }
    

};
